import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';

const FileUploader = (props) => {
  const {
    control,
    formState: { errors },
    clearErrors,
  } = useFormContext();

  const {
    children,
    hideFormError,
    name: propsName,
    clearError,
    shouldUnregister,
    type,
    handleOnchange,
    ...inputProps
  } = props;

  return (
    <>
      <Controller
        name={propsName}
        control={control}
        shouldUnregister={shouldUnregister}
        render={({ field: { onChange, onBlur } }) => (
          <input
            type="file"
            onBlur={onBlur}
            {...inputProps}
            onChange={(event) => {
              if (type === 'file') {
                if (handleOnchange) {
                  handleOnchange(event?.target?.files);
                } else {
                  onChange(event?.target?.files);
                }
              } else {
                onChange(event);
              }
              if (clearError) {
                clearErrors();
              }
            }}
          />
        )}
      />
      {!hideFormError ? (
        <ErrorMessage
          errors={errors}
          name={propsName}
          render={({ message }) => (
            <small className="text-danger">{message}</small>
          )}
        />
      ) : (
        ''
      )}
    </>
  );
};

export default FileUploader;
